import { RydeUiUnit } from "@ryde/shared";

/**
 * A role's history keeps a granted/revoked state per permission, and those two words are the only
 * property values in the drawer that are ours to phrase - everything else is stored data shown as is.
 */
export const getPermissionStateTranslationKey = ({
  entity,
  path,
  value,
}: {
  entity?: RydeUiUnit;
  path: string;
  value: string;
}): string | undefined =>
  entity === "role" && path.startsWith("permissions.")
    ? `auditLog.permissionState.${value}`
    : undefined;
